import { useSelector } from 'react-redux';
import { selectCurrentClient } from '../../../../../../../../CommonSelectors/CommonAreaSelector';
import { UserType } from '../../EstatePlanningFlow.meta';

export const useActionsBar = (userTypeSelected: UserType) => {
  const currentClient = useSelector(selectCurrentClient);

  const principalName = `${currentClient.FirstName} ${currentClient.LastName}`;
  const principalOption = { label: principalName, value: UserType.Principal };

  if (!currentClient.PartnerName) {
    return {
      optionSelected: principalOption,
      options: null,
    };
  }

  const partnerName = `${currentClient.PartnerName}`;
  const partnerOption = { label: partnerName, value: UserType.Partner };

  const options = [principalOption, partnerOption];

  return {
    optionSelected: userTypeSelected === UserType.Principal ? principalOption : partnerOption,
    options,
  };
};
